export default __webpack_public_path__ + "static/media/vine-2.d82d9dc3.png";